import { render, staticRenderFns } from "./MaterialAdd.vue?vue&type=template&id=65c73bc7&"
import script from "./MaterialAdd.vue?vue&type=script&lang=js&"
export * from "./MaterialAdd.vue?vue&type=script&lang=js&"
import style0 from "./MaterialAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports